import React, { useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import { useObserver } from 'mobx-react-lite';
import { GlobalHotKeys } from 'react-hotkeys';

import BodyEnd from '../../_shared/BodyEnd';
import ConfirmModal from '../../_shared/ConfirmModalComponent';
import QuickDrawerHeader from '../../_shared/QuickDrawerHeader';
import { quickDrawerFocus, renderQuickDrawerLoading } from '../../_shared/QuickDrawer';

import ExamExclusionUpdateStore from '../../../../stores/ExamExclusionUpdateStore';
import QuickDrawerStore from '../../../../stores/QuickDrawerStore';

import * as rts from '../../../../constants/routes';
import * as fn from '../../../../utilities/_functions';
import * as oh from '../../../../utilities/operationHelper';

import './ManageExamExclusions.scss';

function ManageExamExclusions(props) {
    const isMounted = useRef(true);
    const validateRef = useRef(null);
    const confirmModalRef = useRef(null);
    const focusTimer = useRef(null);
    const examExclusions = useContext(ExamExclusionUpdateStore);
    const quickDrawer = useContext(QuickDrawerStore);
    const navigate = useNavigate();

    useEffect(() => {
        quickDrawerFocus(props.drawer);

        return () => {
            isMounted.current = false;
            if (focusTimer.current) { clearTimeout(focusTimer.current); focusTimer.current = null; }
            examExclusions.clear();
        }
    }, []) // eslint-disable-line

    const handleExamTemplateChange = event => {
        const { value } = event.target;
        examExclusions.selectedExamTemplateId = value ? value : null;
    }

    const handleSubmit = event => {
        event.preventDefault();

        if (fn.validateForm(validateRef.current)) {
            if (isMounted.current) {
                navigate(`${rts.Exams.PrefillExclusions}/${examExclusions.selectedExamTemplateId}`);
                quickDrawer.deactivateAll();
            }
        }
    }

    return useObserver(() => <>
        <>
            {
                (props.drawer === quickDrawer.drawerOpened) ?
                    <GlobalHotKeys
                        keyMap={{
                            close: ['esc'],
                        }}
                        handlers={{
                            close: event => {
                                props.onCancel(event);
                            },
                        }}
                        allowChanges={true}
                    /> : null
            }
        </>
        <form ref={validateRef} onSubmit={handleSubmit}>
            <fieldset disabled={examExclusions.isSaving}>
                <div className='quick-drawer'>
                    <QuickDrawerHeader
                        drawer={props.drawer}
                        icon={oh.getIcon('exam')}
                        action='Manage'
                        category='Exam Prefill Exclusions'
                        className='exams'
                        onCancel={props.onCancel}
                    />
                    <div className='quick-drawer-body'>
                        {
                            examExclusions.isReady ?
                                <FadeIn>
                                    <div className='exam-prefill-exclusions body-content'>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group validate validate-required mb-0'>
                                                        <label className='required' htmlFor='exam-template'><small>Exam Type</small></label>
                                                        <select
                                                            id='exam-template'
                                                            className='custom-select form-control'
                                                            value={examExclusions.selectedExamTemplateId ? examExclusions.selectedExamTemplateId : ''}
                                                            onChange={handleExamTemplateChange}
                                                        >
                                                            <option value=''></option>
                                                            {
                                                                examExclusions.examTemplates && examExclusions.examTemplates.length > 0 ?
                                                                    examExclusions.examTemplates.map((t, ti) => {
                                                                        return <option
                                                                            key={`exam_template_${ti}`}
                                                                            value={t.id}
                                                                        >{t.name}</option>
                                                                    }) :
                                                                    <option value=''></option>
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </FadeIn> : renderQuickDrawerLoading()
                        }
                    </div>
                    <div className='quick-drawer-action'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='float-right'>
                                    <button
                                        type='button'
                                        className='btn btn-link btn-cancel mr-2'
                                        onClick={props.onCancel}
                                    >Cancel</button>
                                    <button
                                        type='submit'
                                        className='btn btn-primary'
                                        disabled={!examExclusions.selectedExamTemplate}
                                    >Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
        <BodyEnd>
            <ConfirmModal ref={confirmModalRef} />
        </BodyEnd>
    </>)
}

export default ManageExamExclusions;